<template>
    <div>
        <q-select v-model="selectedValue"
                v-bind="$attrs"
                :options="options"
                use-input fill-input hide-selected
                emit-value map-options
                @filter="filterFn">
            <template v-if="selectedValue != null && !$attrs.disable" v-slot:append>
                <q-icon name="cancel" @click.stop.prevent="selectedValue = null" class="cursor-pointer" />
            </template>
        </q-select>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { $http } from "@/boot/http";
import _ from "lodash";

export default defineComponent({
    name: "SelectMasterData",
    emits: ['update:modelValue', 'selected-option'],
    props: {
        typeCode: { type: String, default: ''},
        mapValue: { type: String, default: ''},
        mapType: { type: String, default: 'label'},
        isShowAll: { type: Boolean, default: false }
    },
    setup(props, { emit, attrs }) {
        const options = ref([] as any[]);
        const cloneOptions = ref([] as any[]);
        const selectedValue = ref(null as string | null)
        const fetchMapData = () => {
            setTimeout(() => {
                if (!_.isEmpty(props.mapValue)) {
                    let mapValue = props.mapValue.toLowerCase()
                    if (props.mapType == 'value') {
                        let found = cloneOptions.value.find(v => v.value.toLowerCase() == mapValue);
                        if (!_.isEmpty(found?.value)) {
                            selectedValue.value = String(found.value)
                        }
                    } else {
                        let found = cloneOptions.value.find(v => (v.label.toLowerCase()).indexOf(mapValue) > -1);
                        if (!_.isEmpty(found?.value)) {
                            selectedValue.value = String(found.value)
                        }
                    }
                }
            },500);
        };
        const fetchData = async () => {
            options.value = [] as any[];
            if (!_.isEmpty(props.typeCode)) {
                let resp = await $http.get(`/api/dropdown/findMasterDataByCode/${props.typeCode}`);
                if (props.isShowAll) {
                    options.value.push({ value: "ALL", label: "ALL" } as any);
                }
                _.each(resp.data, v => {
                    options.value.push({
                        value: String(v.dropdownCode),
                        label: v.dropdownName as string
                    } as any);
                });
                cloneOptions.value = options.value
            }
        };
        //eslint-disable-next-line @typescript-eslint/no-unused-vars
        watch(() => attrs.modelValue, (newVal, oldVal) => {
            selectedValue.value = null
            if (newVal) selectedValue.value = attrs.modelValue as any
        }, { immediate: true });
        watch(() => props.typeCode, fetchData, { immediate: true });
        watch(() => props.mapValue, fetchMapData, { immediate: true });
        watch(() => selectedValue.value, () => {
            if (!_.isEmpty(selectedValue.value)) {
                emit('update:modelValue', String(selectedValue.value));
                emit('selected-option', cloneOptions.value.find((f:any) => f.value == selectedValue.value));
            } else {
                emit('update:modelValue', null)
            }       
        });
        return {
            selectedValue,
            options,
            filterFn (val:string, update:any) {
                update(() => {
                    if (val === '') {
                        options.value = cloneOptions.value
                    } else {
                        const needle = val.toLowerCase()
                        options.value = cloneOptions.value.filter(v => (v.label.toLowerCase()).indexOf(needle) > -1);
                    }
                })
            }
        };
    }
});
</script>